/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { PrimaryButton } from '@changegps/horizon-component-library';
import { Box, Grid, Typography } from '@mui/material';

import { ControlledInputs } from '@/components';
import {
  pmPriorityOptions,
  signatureImageOptions,
} from '@/features/settings/hooks/constants';
import { useUserInfo } from '@/features/users';

import {
  useGlobalLetterFormContext,
  useMainFirmContactOptions,
} from '../hooks';

interface LetterOptionsProps {
  handleSave: () => void;
  isPending: boolean;
  // form: any; // Consider using a more specific type from react-hook-form if available
}

export const GlobalLetterOptions = ({
  handleSave,
  isPending,
  // form,
}: LetterOptionsProps) => {
  const form = useGlobalLetterFormContext();
  const mainFirmContactOptions = useMainFirmContactOptions();
  const user = useUserInfo();

  return (
    <Box sx={{ padding: '24px' }}>
      <Grid container spacing={3}>
        {/* Opening Statement */}
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            Opening Statement
          </Typography>
          <ControlledInputs.TextField
            ControllerProps={{
              control: form.control,
              name: `opening`,
            }}
            fullWidth
          />
        </Grid>

        {/* Firm Tag Line */}
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            Firm Tag Line
          </Typography>
          <ControlledInputs.TextField
            ControllerProps={{
              control: form.control,
              name: `tagline`,
            }}
            fullWidth
            placeholder="e.g., Better Advice for a Beautiful Future"
          />
        </Grid>

        {/* Main Firm Contact */}
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            Main Firm Contact
          </Typography>
          <ControlledInputs.Select
            ControllerProps={{
              control: form.control,
              name: `firm_contact`,
            }}
            optionKeys={{ label: 'label', value: 'value' }}
            options={mainFirmContactOptions}
            fullWidth
          />
        </Grid>

        {/* Partner/Manager Priority (Only for XPM users) */}
        {user.connection_type === 'XPM' && (
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
              Partner/Manager Priority
            </Typography>
            <ControlledInputs.Select
              ControllerProps={{
                control: form.control,
                defaultValue: 'Partner',
                name: `pm_priority`,
              }}
              optionKeys={{ label: 'label', value: 'value' }}
              options={pmPriorityOptions}
              fullWidth
            />
          </Grid>
        )}

        {/* Signature Image Title (Takes full width above the 2 fields) */}
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            Signature Image
          </Typography>
          <Grid
            container
            item
            spacing={4}
            xs={12}
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={5}>
              <ControlledInputs.Select
                ControllerProps={{
                  control: form.control,
                  name: `max_width`,
                }}
                optionKeys={{ label: 'label', value: 'value' }}
                options={signatureImageOptions}
                fullWidth
                label="Max Width"
              />
            </Grid>

            <Grid item xs={5}>
              <ControlledInputs.Select
                ControllerProps={{
                  control: form.control,
                  name: `max_height`,
                }}
                optionKeys={{ label: 'label', value: 'value' }}
                options={signatureImageOptions}
                fullWidth
                label="Max Height"
              />
            </Grid>
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Typography variant="body2" color="textSecondary">
              Determines what size a signature image should be scaled down to.
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Box
        sx={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '16px' }}
      >
        <PrimaryButton onClick={handleSave} disabled={isPending}>
          Save Changes
        </PrimaryButton>
      </Box>
    </Box>
  );
};
